import adminManagement from "./admin-management.json";
import analytics from "./analytics.json";
import anonymous from "./anonymous.json";
import assetManagement from "./asset-management.json";
import backoffice from "./backoffice.json";
import bookingDetails from "./booking-details.json";
import bookingDialog from "./booking-dialog.json";
import booking from "./booking.json";
import common from "./common.json";
import dashboard from "./dashboard.json";
import floorPlan from "./floor-plan.json";
import gallery from "./gallery.json";
import header from "./header.json";
import inventoryManagement from "./inventory-management.json";
import kratos from "./kratos.json";
import noOrg from "./no-org.json";
import notifications from "./notifications.json";
import search from "./search.json";
import settings from "./settings.json";

const rsHLV = {
  anonymous,
  booking,
  "booking-details": bookingDetails,
  "booking-dialog": bookingDialog,
  dashboard,
  "floor-plan": floorPlan,
  header,
  kratos,
  notifications,
  settings,
  analytics,
  gallery,
  backoffice,
  "asset-management": assetManagement,
  search,
  common,
  "inventory-management": inventoryManagement,
  "admin-management": adminManagement,
  "no-org": noOrg,
};

export default rsHLV;
